import {createAction} from 'redux-act'

export const setObligationPaymentModalVisible = createAction('SET_OBLIGATION_PAYMENT_MODAL_VISIBLE')
export const setObligationPaymentForm = createAction('SET_OBLIGATION_PAYMENT_FORM')
